import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appElementFocus]'
})
export class ElementFocus {

  constructor(el: ElementRef) {
    setTimeout(() => {
      if (el.nativeElement && el.nativeElement.nodeName === 'ION-INPUT') {
        if (el.nativeElement.lastChild) {
          el.nativeElement.lastChild.focus();
        }
      } else {
        el.nativeElement.focus();
      }
    }, 100);
  }
}
